import React from 'react';
import FieldOfViewDiagram from '../FieldOfViewDiagram';
import { Form, FormGroup, Label, Input, Col} from 'reactstrap';


class FieldOfViewVisualiser extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      heightUpPost: 3,
      laneWidth: 3,
      numLanes: 2,
      pavWidth: 1,
      pavHeight: 0.12,
      mountAngle: 38,
      fovAngle: 10     
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);    
  }

  handleInputChange(event) {
    const target = event.target;
    const value = this.isNumeric(target.value) ? Number(target.value) : target.value;
    const name = target.name;

    this.setState({
      [name]: value
    });

  }

  handleSubmit(event) {
    event.preventDefault();
  }
 

  isNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
  }

  render() {
    return (
      <div>
        
        <FieldOfViewDiagram 
          heightUpPost={this.state.heightUpPost}
          laneWidth={this.state.laneWidth}
          numLanes={this.state.numLanes}
          pavWidth={this.state.pavWidth}
          pavHeight={this.state.pavHeight}
          mountAngle={this.state.mountAngle}
          fovAngle={this.state.fovAngle}        
        />
        

        <Form>
          <FormGroup row>
            <Col xs={12} sm={6}>
              <Label for="fovAngle">Field of View Angle (°; full arc)</Label>
              <Input 
                type="number" 
                name="fovAngle" 
                id="fovAngle" 
                placeholder="in degrees e.g. 16" 
                value={this.state.fovAngle}
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} sm={6}>
              <Label for="mountAngle">Mount Angle (°)</Label>
              <Input 
                type="number" 
                name="mountAngle" 
                id="mountAngle" 
                placeholder="in degrees e.g. 38" 
                value={this.state.mountAngle}
                onChange={this.handleInputChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col xs={12} sm={6}>
              <Label for="heightUpPost">Sensor Height up Post (m)</Label>
              <Input 
                type="number" 
                name="heightUpPost" 
                id="heightUpPost" 
                placeholder="in metres e.g. 3" 
                value={this.state.heightUpPost}
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} sm={6}>
              <Label for="laneWidth">Lane Width (m)</Label>
              <Input 
                type="number" 
                name="laneWidth" 
                id="laneWidth" 
                placeholder="in metres" 
                value={this.state.laneWidth}
                onChange={this.handleInputChange}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Col xs={12} sm={6}>
              <Label for="numLanes">Number of Lanes</Label>
              <Input 
                type="number" 
                name="numLanes" 
                id="numLanes" 
                placeholder="e.g. 2 for dual carriageway" 
                value={this.state.numLanes}
                onChange={this.handleInputChange}
              />
            </Col>
            <Col xs={12} sm={6}>
              <Label for="pavWidth">Pavement/Verge Width (m)</Label>
              <Input 
                type="number" 
                name="pavWidth" 
                id="pavWidth" 
                placeholder="in metres from post to road" 
                value={this.state.pavWidth}
                onChange={this.handleInputChange}
              />
            </Col>
          </FormGroup>       
          <FormGroup row>
            <Col xs={12} sm={6}>
              <Label for="pavHeight">Pavement/Verge Height (m)</Label>
              <Input 
                type="number" 
                name="pavHeight" 
                id="pavHeight" 
                placeholder="in metres, e.g. 0.12" 
                value={this.state.pavHeight}
                onChange={this.handleInputChange}
              />
            </Col>
          </FormGroup>                                 
        </Form>


      </div>
    );
  }

}


export default FieldOfViewVisualiser;


// WEBPACK FOOTER //
// ./src/components/FieldOfViewVisualiser/index.js